// extracted by mini-css-extract-plugin
export default {"wrapper":"app_wrapper__N1u9G","main":"app_main__2XFNm","indent":"app_indent__zdwY9","app_btn":"app_app_btn__PDNIS"};